export interface ActionConfiguration {
  ActionType: string;
  ReqtypeId: number;
  ReqtypeName?: string;
  IsAllowed: boolean;
  WorkFlowStatus?: number[];
  ReqStatus?: string;
}

export const isActionAllowed = (
  actionType: string,
  reqTypeId: number | string | undefined,
  actionConfigurations: ActionConfiguration[],
  options?: {
    workFlowStatusId?: number | string;
    reqStatus?: string;
  }
): boolean => {
  if (!actionConfigurations?.length) return true;

  const numReqTypeId = Number(reqTypeId);
  if (isNaN(numReqTypeId)) return true;

  const matchingConfig = actionConfigurations.find((config) => {
    if (config.ActionType !== actionType || config.ReqtypeId !== numReqTypeId)
      return false;

    if (config.WorkFlowStatus?.length) {
      const numWorkFlowStatusId = Number(options?.workFlowStatusId);
      if (isNaN(numWorkFlowStatusId)) return false;
      if (!config.WorkFlowStatus.includes(numWorkFlowStatusId)) return false;
    }

    if (config.ReqStatus) {
      if (
        !options?.reqStatus ||
        config.ReqStatus.toLowerCase() !== options.reqStatus.toLowerCase()
      )
        return false;
    }

    return true;
  });

  if (!matchingConfig) return true;
  return matchingConfig.IsAllowed;
};
